export const sources={};export const img={src:"__VITE_ASSET__HFnSo_t2ji54Ii8fKeJyow__",w:640,h:640};export default{sources:sources,img:img};